var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4",staticStyle:{"width":"100%"}},[_c('figure',[_c('img',{attrs:{"src":_vm.block.image.url}}),(_vm.block.caption)?_c('figcaption',[_vm._v(_vm._s(_vm.block.caption))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }